import { devTools } from "@/components/debug-panel/DevToolsStore";
import { twMerge } from "@/utils/twMerge";

export function getBoundaryClassNames(
  visible: "left" | "right" | boolean,
  variant?: "focused" | "computed",
): string | undefined {
  if (!visible || !devTools.showExpressionBoundaries) {
    return undefined;
  }

  return twMerge(
    visible !== "right" &&
      "before:content-[''] before:pointer-events-none before:absolute before:-top-[2px] before:left-0 before:w-[4px] before:h-[calc(100%+4px)] before:border before:border-r-0 before:rounded-l-4",
    visible !== "right" &&
      (variant === "focused"
        ? "before:border-blue-300 dark:before:border-blue-700"
        : "before:border-green-400 dark:before:border-green-600"),

    visible !== "left" &&
      "after:content-[''] after:pointer-events-none after:absolute after:-top-[2px] after:right-0 after:w-[4px] after:h-[calc(100%+4px)] after:border after:border-l-0 after:rounded-r-4",
    visible !== "left" &&
      (variant === "focused"
        ? "after:border-blue-300 dark:after:border-blue-700"
        : "after:border-green-400 dark:after:border-green-600"),
  );
}
